// src/pages/RefundPolicy.tsx
import React, { useEffect } from "react";

export default function RefundPolicy() {
  useEffect(() => {
    document.title = "Cancellations & Refunds • Backlink Banana";
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-blue-700 mb-6 text-center">
        Cancellations & Refunds
      </h1>
      <p className="text-gray-700 text-base leading-relaxed mb-4">
        At Backlink Banana, all payments are final. Due to the nature of our platform providing digital data and instant access to combination of website sourcing API's, we do not offer refunds once credits that have been purchased or used.
      </p>
      <p className="text-gray-700 text-base leading-relaxed mb-4">
        Please review your credit balance and usage carefully before making a payment. If you experience any technical issues, billing discrepancies, or believe there was an error in your purchase, reach out to us through the{" "}
        <a href="/contact-us" className="text-blue-600 underline">Contact Us</a> page. We are happy to assist in resolving issues related to accidental charges or platform malfunctions.
      </p>
      <p className="text-gray-700 text-base leading-relaxed">
        By using our platform, you agree to these terms regarding cancellations and refunds.
      </p>
    </div>
  );
}
